import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import CircularProgress from "@material-ui/core/CircularProgress";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";

export default class EditAdminDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle id="form-dialog-title">
          {this.props.admin
            ? languages.admins.editAdmin
            : languages.admins.addAdmin}
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
            {!this.props.admin && (
              <DialogContentText style={{ paddingBottom: 5 }}>
                {languages.admins.description3}
              </DialogContentText>
            )}
            <TextField
              disabled={this.props.admin !== undefined}
              autoFocus
              margin="dense"
              label={languages.admins.email}
              value={this.props.name}
              name="name"
              onChange={this.props.handleChange}
              type="text"
              fullWidth
            />
            {(this.props.errorMessage || "").length > 0 && (
              <DialogContentText style={{ color: "red" }}>
                {this.props.errorMessage}
              </DialogContentText>
            )}
            <div style={{ fontWeight: 500, marginTop: 15 }}>
              {languages.admins.rights + ":"}
            </div>
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.manageGeneral || false}
                  onChange={this.props.handleSwitch}
                  color="primary"
                  name="manageGeneral"
                />
              }
              label={languages.admins.manageGeneral}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.manageTeams}
                  onChange={this.props.handleSwitch}
                  color="primary"
                  name="manageTeams"
                />
              }
              label={languages.admins.manageTeams}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.manageFormat}
                  onChange={this.props.handleSwitch}
                  color="primary"
                  name="manageFormat"
                />
              }
              label={languages.admins.manageFormat}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.manageSchedule}
                  onChange={this.props.handleSwitch}
                  color="primary"
                  name="manageSchedule"
                />
              }
              label={languages.admins.manageSchedule}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.managePresentation}
                  onChange={this.props.handleSwitch}
                  color="primary"
                  name="managePresentation"
                />
              }
              label={languages.admins.managePresentation}
            />
            {this.props.managePresentation && (
              <FormGroup style={{ marginLeft: 15 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.props.managePublicWebsite}
                      onChange={this.props.handleSwitch}
                      color="primary"
                      name="managePublicWebsite"
                    />
                  }
                  label={languages.admins.managePublicWebsite}
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.props.manageSlideshow}
                      onChange={this.props.handleSwitch}
                      color="primary"
                      name="manageSlideshow"
                    />
                  }
                  label={languages.admins.manageSlideshow}
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.props.manageDesign}
                      onChange={this.props.handleSwitch}
                      color="primary"
                      name="manageDesign"
                    />
                  }
                  label={languages.admins.manageDesign}
                />
              </FormGroup>
            )}
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.manageResults}
                  onChange={this.props.handleSwitch}
                  color="primary"
                  name="manageResults"
                />
              }
              label={languages.admins.manageResults}
            />
            {this.props.manageResults && (
              <FormGroup style={{ marginLeft: 15 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.props.managePhases}
                      onChange={this.props.handleSwitch}
                      color="primary"
                      name="managePhases"
                    />
                  }
                  label={languages.admins.managePhases}
                />
                <FormHelperText>
                  {languages.admins.managePhasesDescription}
                </FormHelperText>
              </FormGroup>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <div style={{ position: "relative" }}>
              <Button
                onClick={this.props.handleSubmit}
                disabled={this.props.submitDisabled}
                variant="contained"
                color="primary"
                type="submit"
              >
                {this.props.admin
                  ? languages.general.save
                  : languages.general.add}
              </Button>
              {this.props.searchingUser && (
                <CircularProgress
                  size={24}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: -12,
                    marginLeft: -12,
                  }}
                />
              )}
            </div>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
